/** @description gets JWT from local storage. Used in profile page */
export const getJwt = (): string | undefined => {
  if (!localStorage.vuex) {
    return undefined;
  }
  return JSON.parse(localStorage.vuex)?.auth?.idToken;
};
